import { fNow } from '@/shared/utils/format-time';
import { create } from 'zustand';
import { ISerialPortDevices, ISerialPortList, ISerialPortsLogs, ISerialPortStore } from './types';

export const useSerialPortStore = create<ISerialPortStore>()((set) => ({
  logs: [],
  data: {
    portList: [],
    livestockRFIDScannerValue: null,
    livestockScalesValue: null,
    livestockBarcodeScannerValue: null,
    connectedDevices: {
      livestockRFIDScanner: false,
      livestockScales: false
    }
  },

  setPorts: (portList: ISerialPortList[]) =>
    set((crr) => {
      const portListSorted = portList.sort((a, b) => {
        const numA = parseInt(a.path.replace(/\D/g, '')) || 0;
        const numB = parseInt(b.path.replace(/\D/g, '')) || 0;

        return numA - numB;
      });

      return { data: { ...crr.data, portList: portListSorted } };
    }),
  setLivestockRFIDScanner: (livestockRFIDScanner: string | null) =>
    set((crr) => ({ data: { ...crr.data, livestockRFIDScannerValue: livestockRFIDScanner } })),
  setLivestockScales: (livestockScales: string | null) =>
    set((crr) => ({ data: { ...crr.data, livestockScalesValue: livestockScales } })),
  setLivestockBarcodeScanner: (livestockBarcodeScanner: string | null) =>
    set((crr) => ({ data: { ...crr.data, livestockBarcodeScannerValue: livestockBarcodeScanner } })),
  setConnectDevice: (device: ISerialPortDevices, value: boolean) =>
    set((crr) => ({ data: { ...crr.data, connectedDevices: { ...crr.data.connectedDevices, [device]: value } } })),
  addLog: (type: ISerialPortsLogs['type'], message: string) => {
    const log: ISerialPortsLogs = {
      type,
      message,
      time: fNow()
    };

    set((crr) => {
      const logs = [log, ...crr.logs];

      console.log({ logs });

      return { logs };
    });
  },
  clearLogs: () => set((crr) => ({ data: { ...crr.data, logs: [] } })),
  reset: () =>
    set((crr) => ({
      data: {
        ...crr.data,
        portList: [],
        logs: [],
        livestockRFIDScannerValue: null,
        livestockScalesValue: null,
        connectedDevices: { livestockRFIDScanner: false, livestockScales: false }
      }
    }))
}));
